import * as APITypes from "~/API";
import { getUnitList } from "~/services/server";
import { buildPropertyMap, buildBuildingMap } from "../helpers";
import type { EntityListData, EntityListOptions } from "~/types";

export const formatUnitOptions = (
  unitList: APITypes.Unit[],
  propertyMap: Record<string, APITypes.Property>,
  buildingMap: Record<string, APITypes.Building>
): EntityListOptions[] => {
  return unitList.map((unit) => {
    const building = buildingMap[unit.buildingID];
    const propertyName = building?.propertyID
      ? propertyMap[building.propertyID]?.name
      : undefined;
    const unitName = unit.name != null ? String(unit.name) : unit.id;
    const buildingName = building?.name ?? "—";
    const propertyLabel = propertyName ?? "—";
    return {
      value: unit.id,
      text: `Unit: ${unitName} - Building: ${buildingName} - Property: ${propertyLabel}`,
    };
  });
};

export const getUnitEntityList = async (
  ownerID: string,
  ownerType: APITypes.OwnerType
): Promise<EntityListData> => {
  const unitList = await getUnitList({ ownerID, ownerType });
  const propertyMap = await buildPropertyMap(ownerID, ownerType);
  const buildingMap = await buildBuildingMap(ownerID, ownerType);

  return {
    propertyList: [],
    buildingList: [],
    unitList: unitList.data,
    serviceRequestList: [],
    amenityList: [],
    propertyMap,
    buildingMap,
    unitMap: {},
  };
};
